/* global api */
import { Questionnaire, User, LogEntry } from '../../models'

const state = {
  currentPage: 1,
  questionnaires: [],
  selectedQuestionnaireId: 0,
  formSubmitted: false,
  failedScreening: false,
  failureDescription: '',
  singleStep: false,
  masks: {
    phone: {
      phone: true,
      phoneRegionCode: 'US',
      delimiter: '-'
    },
    zip: {
      numericOnly: true,
      delimiter: '-',
      blocks: [5, 4]
    },
    temperature: {
      numericOnly: true,
      delimiter: '.',
      blocks: [3, 1]
    }
  },
  hotspots: null
}
const mutations = {
  commitCurrentPage (state, meta) {
    state.currentPage = meta
  },
  commitQuestionnaires (state, meta) {
    state.questionnaires = meta
  },
  commitSelectedQuestionnaireId (state, { id, store = true }) {
    state.selectedQuestionnaireId = id
    if (store) {
      window.sessionStorage.setItem('questionnaireId', JSON.stringify(id))
    }
  },
  commitNextPage (state) {
    state.currentPage++
  },
  commitPreviousPage (state) {
    state.currentPage--
  },
  commitFormSubmitted (state, meta) {
    state.formSubmitted = meta
  },
  commitFailedScreening (state, meta) {
    state.failedScreening = meta
  },
  commitFailureDescription (state, meta) {
    state.failureDescription = meta
  },
  commitSingleStep (state, meta) {
    state.singleStep = meta
  },
  commitHotspots (state, meta) {
    state.hotspots = meta
  }
}
const actions = {
  async initialiseStore ({ commit }) {
    if (window.sessionStorage.getItem('questionnaireId')) {
      const questionnaireId = await JSON.parse(window.sessionStorage.getItem('questionnaireId'))
      await commit('commitSelectedQuestionnaireId', { id: questionnaireId })
    }
  },
  async fetchQuestionaires ({ commit, dispatch, rootState }, meta) {
    console.log('fetchQuestionaires')
    try {
      const startLogEntry = new LogEntry('forms/fetchQuestionaires', 'Start')
      await dispatch('support/addLog', startLogEntry, { root: true })

      const metaLogEntry = new LogEntry('forms/fetchQuestionaires meta', meta)
      await dispatch('support/addLog', metaLogEntry, { root: true })

      const method = 'post'
      const result = await api.call(method, rootState.apiUrl + 'getQuestionnaires', meta)

      const questionnaires = []
      result.message.forEach(questionnaire => {
        if (questionnaire.route !== undefined && questionnaire.route !== null && questionnaire.route.length > 0) {
          questionnaires.push(new Questionnaire(questionnaire))
        }
      })
      await commit('commitQuestionnaires', questionnaires)
      await dispatch('setInitStepComplete', 'fetchQuestionaires', { root: true })

      if (questionnaires.length === 0) {
        const user = new User(rootState.authentication.user)
        const alertData = {
          variant: 'danger',
          message: 'Warning',
          alerts: ['There are no forms for your current Branch: ' + user.branch]
        }
        dispatch('setPageAlertInformation', alertData, { root: true })
      }

      const endLogEntry = new LogEntry('forms/fetchQuestionaires', 'End: ' + result.success)
      await dispatch('support/addLog', endLogEntry, { root: true })

      return result.success
    } catch (error) {
      const logEntry = new LogEntry('forms/fetchQuestionaires error', error)
      await dispatch('support/addLog', logEntry, { root: true })
      await dispatch('setInitFailure', true, { root: true })
    }
  },
  async fetchHotspots ({ commit, dispatch, rootState }, state) {
    try {
      const startLogEntry = new LogEntry('forms/fetchHotspots', 'Start')
      await dispatch('support/addLog', startLogEntry, { root: true })

      const metaLogEntry = new LogEntry('forms/fetchHotspots meta', state)
      await dispatch('support/addLog', metaLogEntry, { root: true })

      const result = await api.get(rootState.hotspotsUrl + state)

      await commit('commitHotspots', result)
      await dispatch('setInitStepComplete', 'fetchHotspots', { root: true })

      const endLogEntry = new LogEntry('forms/fetchHotspots', 'End: ' + result.success)
      await dispatch('support/addLog', endLogEntry, { root: true })

      return result.success
    } catch (error) {
      const logEntry = new LogEntry('forms/fetchHotspots error', error)
      await dispatch('support/addLog', logEntry, { root: true })
      await dispatch('setInitFailure', true, { root: true })
    }
  },
  async addFormResults ({ state, dispatch, rootState }, meta) {
    try {
      const branchUser = rootState.selectedUser
      const user = new User(rootState.authentication.user)
      const results = {}
      results.branch_id = user.primaryBranchId
      results.bfm_name = user.name
      results.bfm_id = user.id
      results.form_id = state.selectedQuestionnaireId
      results.user_name = branchUser.itemName
      console.log('BRANCH USER')
      console.log(branchUser.itemName)
      results.user_id = branchUser.itemId
      results.user_type = branchUser.type
      results.failed_screening = state.failedScreening
      results.failed_description = state.failureDescription
      results.answers = { ...meta }
      results.visitor = rootState.visitorInformation
      results.online = navigator.onLine
      if (this.isSelfMode) {
        results.user_name = 'Self Attest'
        console.log('THIS IS SELF MODE')
      }
      for (const [key, value] of Object.entries(results.answers)) {
        results.answers[key] = (Array.isArray(value) ? { ...value } : value)
      }

      if (navigator.onLine) {
        const method = 'post'
        console.log('RESULTS')
        console.log(results)
        try {
          const result = await api.call(method, rootState.apiUrl + 'addFormResults', results)
          if (result.success === undefined || !result.success) {
            const logData = {}
            logData.result = result
            logData.results = results
            const logEntry = new LogEntry('forms/addFormResults error (0x1)', logData)
            await dispatch('support/addLog', logEntry, { root: true })
            dispatch('offline/addForm', results, { root: true })
            console.log(results)
          } else {
            if (results.visitor && !results.visitor.user_id) {
              console.log('Trying to remove a First Time Visitor')
              console.log(results)
              const itemNameParts = [results.visitor.firstName, results.visitor.lastName]
              const searchData = `${results.visitor.firstName} ${results.visitor.lastName} -  Visitor`
              const itemName = `${results.visitor.firstName} ${results.visitor.lastName}`
              const visitor = {
                itemId: result.message.user_id,
                itemName,
                itemNameParts,
                searchData,
                type: 'visitors'
              }
              console.log('Adding Visitor To BFMS')
              dispatch('addVisitorToBFMs', visitor, { root: true })
              console.log('Results UUID')
              console.log(results.visitor.id)
              await dispatch('removeNewVisitor', results.visitor.id, { root: true })
            }
          }
          return result.success
        } catch (error) {
          const logEntry = new LogEntry('forms/addFormResults error (0x2)', results)
          console.log(error)
          await dispatch('support/addLog', logEntry, { root: true })
          dispatch('offline/addForm', results, { root: true })
        }
      } else {
        dispatch('offline/addForm', results, { root: true })
      }
    } catch (error) {
      const logData = {}
      logData.error = error
      logData.meta = meta
      const logEntry = new LogEntry('forms/addFormResults error (0x3)', logData)
      await dispatch('support/addLog', logEntry, { root: true })

      console.log('addFormResults error')
      console.log(error)
    }
  },
  async submitVaccineData ({ state, dispatch, rootState }, meta) {
    try {
      const branchUser = rootState.selectedUser
      const user = new User(rootState.authentication.user)
      const results = {}
      results.branch_id = user.primaryBranchId
      results.user_name = branchUser.itemName
      results.user_id = branchUser.itemId
      results.user_type = branchUser.type
      results.doseOneDate = meta.doseOneDate
      results.doseTwoDate = meta.doseTwoDate
      results.sideEffects = meta.sideEffects
      results.sideEffectsDose2 = meta.sideEffectsDose2
      results.declined = meta.declined
      results.online = navigator.onLine
      results.vaccine_type = meta.vaccineType

      if (navigator.onLine) {
        const method = 'post'
        try {
          const result = await api.call(method, rootState.apiUrl + 'addVaccineTracking', results)
          if (result.success === undefined || !result.success) {
            const logData = {}
            logData.result = result
            logData.results = results
            const logEntry = new LogEntry('forms/addVaccineTracking error (0x1)', logData)
            await dispatch('support/addLog', logEntry, { root: true })
            dispatch('offline/addForm', results, { root: true })
          }
          return result.success
        } catch (error) {
          const logEntry = new LogEntry('forms/addVaccineTracking error (0x2)', results)
          await dispatch('support/addLog', logEntry, { root: true })
          dispatch('offline/addForm', results, { root: true })
        }
      } else {
        dispatch('offline/addForm', results, { root: true })
      }
    } catch (error) {
      const logData = {}
      logData.error = error
      logData.meta = meta
      const logEntry = new LogEntry('forms/submitVaccineData error (0x3)', logData)
      await dispatch('support/addLog', logEntry, { root: true })

      console.log('submitVaccineData error')
      console.log(error)
    }
  },
  setCurrentPage ({ commit }, meta) {
    commit('commitCurrentPage', meta)
  },
  setSelectedQuestionnaireId ({ commit }, meta) {
    commit('commitSelectedQuestionnaireId', { id: meta, store: true })
  },
  nextPage ({ commit, state }) {
    const questionnaire = state.questionnaires.find(questionnaire => questionnaire.id === state.selectedQuestionnaireId)
    if (state.currentPage < questionnaire.questions.length) {
      commit('commitNextPage')
    }
  },
  previousPage ({ commit, state }) {
    if (state.currentPage > 1) {
      commit('commitPreviousPage')
    }
  },
  setFormSubmitted ({ commit }, meta) {
    commit('commitFormSubmitted', meta)
  },
  setFailedScreening ({ commit }, meta) {
    commit('commitFailedScreening', meta)
  },
  setFailureDescription ({ commit }, meta) {
    commit('commitFailureDescription', meta)
  },
  isSingleStep ({ commit }) {
    commit('commitSingleStep', true)
  },
  isMultiStep ({ commit }, meta) {
    commit('commitSingleStep', false)
  }
}
const getters = {
  check: state => state.questionnaires.length > 0,
  count: state => state.questionnaires.length,
  questionnaires: state => {
    const questionnairesTmp = state.questionnaires
    return questionnairesTmp
  },
  currentPage: state => {
    return state.currentPage
  },
  numberOfPages: (state, getters) => {
    if (state.selectedQuestionnaireId === 0) {
      return 0
    }
    const questionnaire = state.questionnaires.find(questionnaire => questionnaire.id === state.selectedQuestionnaireId)
    if (questionnaire === undefined) {
      return 0
    }
    const questions = questionnaire.questions

    const pagesTmp = []
    questions.forEach((value, key) => {
      if (pagesTmp[value.page] !== undefined) {
        pagesTmp[value.page]++
      } else {
        pagesTmp[value.page] = 1
      }
    })
    const pages = pagesTmp.filter(page => page !== undefined)
    if (questionnaire.route === 'entry-screening') {
      if (!getters.hasHotspots) {
        return pages.length - 1
      }
    }
    return pages.length
  },
  selectedQuestionnaireId: state => {
    return state.selectedQuestionnaireId
  },
  currentQuestionnaire: state => {
    return state.questionnaires.find(questionnaire => questionnaire.id === state.selectedQuestionnaireId)
  },
  viewingQuestionnaire: state => {
    return state.selectedQuestionnaireId !== 0
  },
  questions: state => {
    if (state.selectedQuestionnaireId > 0) {
      const questionnaire = state.questionnaires.find(questionnaire => questionnaire.id === state.selectedQuestionnaireId)
      return (questionnaire !== undefined) ? questionnaire.questions : []
    }
    return []
  },
  findQuestions: state => {
    return (state.questionnaire !== undefined) ? state.questionnaire.questions : []
  },
  formSubmitted: state => {
    return state.formSubmitted
  },
  failedScreening: state => {
    return state.failedScreening
  },
  failureDescription: state => {
    return state.failureDescription
  },
  singleStep: state => {
    return state.singleStep
  },
  masks: state => {
    return state.masks
  },
  findQuestionnaireByRoute: (state) => (route) => {
    if (state.questionnaires !== undefined) {
      return state.questionnaires.find(questionnaire => questionnaire.route === route)
    }
    return {}
  },
  hotspots: state => state.hotspots,
  hasHotspots: state => {
    return state.hotspots !== null && state.hotspots.length > 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
